import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";

import { cloudloyalty, genericSupplierEndpoint, premmiar } from "Services/Apis/clients";

export const getProductBySku = createAsyncThunk(
  "product/getBySku",
  async (sku, { getState, rejectWithValue }) => {
    try {
      const { user } = getState().oidc;

      const { data } = await cloudloyalty(user).get(`/v2/products/skus/${sku}`);

      return data;
    } catch (err) {
      console.log(err);

      return rejectWithValue(err.response.data.errors[0]);
    }
  }
)

export const getGSProductByOriginalId = createAsyncThunk(
  "GSProduct/getByOriginalId",
  async (originalId, { getState, rejectWithValue }) => {
    try {
      const { user } = getState().oidc;

      const { data } = await genericSupplierEndpoint(user).get(`/Product/Sku/${originalId}`);

      return data;
    } catch (err) {
      console.log(err);

      return rejectWithValue(err.response.data.errors[0]);
    }
  }
)

export const getProductRating = createAsyncThunk(
  "product/getRating",
  async (productSku, { getState, rejectWithValue }) => {
    try {
      const { user } = getState().oidc;

      const { data } = await premmiar(user).get(`/RatingAverage/Average?identification=${productSku}&type=1`);

      return data;
    } catch (err) {
      console.log(err);

      return rejectWithValue(err.response.data.errors[0]);
    }
  }
)

export const getRelatedProductsByOriginalId = createAsyncThunk(
  "genericSupplier/getRelatedProducts",
  async (originalId, { getState, rejectWithValue }) => {
    try {
      const { user } = getState().oidc;

      const { data } = await genericSupplierEndpoint(user).get(`/product/relatedProducts/${originalId}`);

      return data;
    } catch (err) {
      console.log(err);

      return rejectWithValue(err);
    }
  }
)

const initialState = {
  productData: null,
  productIsLoading: false,
  getProductHasError: false,

  productRatingData: null,
  isProductRatingLoading: false,
  getProductRatingHasError: false,
};

const productSlice = createSlice({
  name: "product",
  initialState,
  reducers: {
    resetProductData: (state) => {
      state.productData = null;
      state.productIsLoading = false;
      state.getProductHasError = false;
    }
  },
  extraReducers: (builder) => {
    builder.addCase(getProductBySku.pending, (state) => {
      state.productIsLoading = true;
    })

    builder.addCase(getProductBySku.fulfilled, (state, action) => {
      state.productIsLoading = false;
      state.productData = action.payload;
    })

    builder.addCase(getProductBySku.rejected, (state) => {
      state.productIsLoading = false;
      state.getProductHasError = true;
    })

    builder.addCase(getProductRating.pending, (state) => {
      state.productIsLoading = true;
    })

    builder.addCase(getProductRating.fulfilled, (state, action) => {
      state.productIsLoading = false;
      state.productData = action.payload;
    })

    builder.addCase(getProductRating.rejected, (state) => {
      state.isProductRatingLoading = false;
      state.getProductHasError = true;
    })
  }
})

export const { resetProductData } = productSlice.actions;
export default productSlice.reducer;
